import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Button,
  Spinner,
  Alert,
} from "reactstrap";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class EditDestinations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Destinations", link: "/destinations" },
        { title: "Edit Destination", link: "#" },
      ],
      destinationName: "",
      selectedTypes: [],
      loading: true,
      error: null,
      submitting: false,
      success: null,
    };

    this.destinationTypeOptions = [
      { value: "Spiritual", label: "Spiritual" },
      { value: "Leisure", label: "Leisure" },
      { value: "Experiential", label: "Experiential" },
    ];
  }

  componentDidMount() {
    this.fetchDestinationData();
  }

  // ✅ Fetch existing data by ID
  fetchDestinationData = async () => {
    try {
      const destinationId = this.props.router.params.id;
      const response = await fetch(`${config.API_BASE_URL}/destinations/${destinationId}`);
      const data = await response.json();

      if (response.ok) {
        const selectedTypes =
          Array.isArray(data.destination_type) && data.destination_type.length > 0
            ? data.destination_type.map((type) => ({
                value: type,
                label: type,
              }))
            : [];

        this.setState({
          destinationName: data.destination_name || "",
          selectedTypes,
          loading: false,
        });
      } else {
        this.setState({
          error: data.message || "Failed to load destination data",
          loading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching destination:", error);
      this.setState({
        error: "Error fetching destination data",
        loading: false,
      });
    }
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleTypeChange = (selectedOptions) => {
    this.setState({ selectedTypes: selectedOptions || [] });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitting: true, success: null, error: null });

    try {
      const destinationId = this.props.router.params.id;
      const { destinationName, selectedTypes } = this.state;

      const payload = {
        destination_name: destinationName,
        destination_type: selectedTypes.map((type) => type.value),
      };

      const response = await fetch(`${config.API_BASE_URL}/destinations/${destinationId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        this.setState({ success: "Destination updated successfully!", submitting: false });
        setTimeout(() => this.props.router.navigate("/destinations"), 1200);
      } else {
        this.setState({
          error: data.message || "Failed to update destination",
          submitting: false,
        });
      }
    } catch (error) {
      console.error("Error updating destination:", error);
      this.setState({
        error: "Error updating destination",
        submitting: false,
      });
    }
  };

  handleCancel = () => {
    this.props.router.navigate("/destinations");
  };

  render() {
    const {
      loading,
      error,
      submitting,
      success,
      destinationName,
      selectedTypes,
    } = this.state;

    if (loading) {
      return (
        <div className="page-content">
          <Container fluid>
            <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
              <Spinner color="primary" />
            </div>
          </Container>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Edit Destination"
              breadcrumbItems={this.state.breadcrumbItems}
            />

            {error && <Alert color="danger">{error}</Alert>}
            {success && <Alert color="success">{success}</Alert>}

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Destination Name</Label>
                            <input
                              type="text"
                              name="destinationName"
                              className="form-control"
                              placeholder="Enter Destination Name"
                              value={destinationName}
                              onChange={this.handleInputChange}
                              required
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Destination Types</Label>
                            <Select
                              isMulti
                              options={this.destinationTypeOptions}
                              value={selectedTypes}
                              onChange={this.handleTypeChange}
                              placeholder="Select Destination Types..."
                              classNamePrefix="react-select"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-4">
                        <Col className="d-flex justify-content-end">
                          <Button
                            type="submit"
                            color="primary"
                            className="me-2"
                            disabled={submitting}
                          >
                            {submitting ? (
                              <>
                                <Spinner size="sm" className="me-2" /> Updating...
                              </>
                            ) : (
                              "Update Destination"
                            )}
                          </Button>
                          <Button
                            type="button"
                            color="secondary"
                            onClick={this.handleCancel}
                            disabled={submitting}
                          >
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(EditDestinations);
